import React, { createContext, useContext, useMemo, useState } from 'react';
import { Carousel } from 'antd';
import {
  TvsLogo,
  MahindraVehicles,
  MahindraTruckes,
  HondaCars,
  RenaultCars,
  CEMHVehicles,
} from '../../utils/imgConstants';
import SupportModal from './SupportModal';
import './AuthShell.css';

const sliders = [
  { index: 0, image: MahindraVehicles },
  { index: 1, image: MahindraTruckes },
  { index: 2, image: HondaCars },
  { index: 3, image: RenaultCars },
  { index: 4, image: CEMHVehicles },
];

/**
 * Lets any auth screen open the shared "Contact IT support" popup that the
 * shell already owns — e.g. from inside an error message about a missing
 * email ID — without each screen mounting its own modal.
 */
const SupportContext = createContext<() => void>(() => {});

export const useSupport = () => useContext(SupportContext);

interface AuthShellProps {
  tagline: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Common chrome for every auth screen: gradient showcase on the left,
 * glass card with the TVS Mobility logo + footer on the right.
 */
const AuthShell: React.FC<AuthShellProps> = ({ tagline, children }) => {
  const [supportOpen, setSupportOpen] = useState(false);
  const openSupport = useMemo(() => () => setSupportOpen(true), []);

  return (
  <div className="login-page">
    <div className="login-showcase">
      <div className="login-showcase-inner">
        <h1 className="login-showcase-title">One sign-in for the<br />TVS universe</h1>
        <p className="login-showcase-subtitle">
          Secure single sign-on across every TVS application — powered by Azure AD.
        </p>
        <Carousel autoplay autoplaySpeed={1250} dots>
          {sliders.map((item, index) => (
            <div className="text-center" key={index}>
              <img src={item.image} alt="" />
            </div>
          ))}
        </Carousel>
      </div>
    </div>

    <div className="login-panel">
      <div className="login-card">
        <div className="login-card-head">
          <img src={TvsLogo} alt="TVS Mobility" />
          <div className="login-tagline">{tagline}</div>
        </div>

        <SupportContext.Provider value={openSupport}>
          {children}
        </SupportContext.Provider>

        <div className="login-card-foot">
          © {new Date().getFullYear()} TVS Universe · Need help?{' '}
          <button
            type="button" className="login-link"
            onClick={openSupport}
          >
            Contact IT support
          </button>
        </div>
      </div>
    </div>

    <SupportModal open={supportOpen} onClose={() => setSupportOpen(false)} />
  </div>
  );
};

export default AuthShell;
